var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mediaList && _vm.mediaList.length>0)?_c('div',{staticClass:"media-list"},_vm._l((_vm.mediaList),function(item,index){return _c('div',{key:index,staticClass:"media-item"},[_vm._v("\n    123321\n    ")])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }